import {
  IonButton,
  IonPage,
  IonTitle,
  useIonViewWillEnter,
  useIonViewWillLeave,
} from "@ionic/react";

import { useHeader } from "#/core/HeaderContext";
import AppContent from "#/features/shared/AppContent";
import styles from './infoPage.module.css';
import { useEffect, useState } from "react";
import { useFetch } from "@mantine/hooks";
import { useInterceptLinks } from "#/helpers/useInterceptLink";
import { CenteredSpinner } from "#/features/shared/CenteredSpinner";

type WPPage = {
  content: {
    protected: boolean;
    rendered: string;
  };
  date: string;
  id: number;
  link: string;
  slug: string;
  title: {
    rendered: string;
  };

};

export default function InfoPage() {
  const { setHeader } = useHeader();
  const { data, loading, error, refetch, abort } = useFetch<WPPage[]>('https://content.democrats.com/wp-json/wp/v2/pages?slug=info');
  const [subpageURL, setSubpageURL] = useState('');
  const [subpageInfo, setSubpageInfo] = useState<WPPage[] | null>(null);
  const [subpageLoading, setSubpageLoading] = useState(false);
  const [subpageError, setSubpageError] = useState('');
  
  useEffect(() => {
    if (!subpageURL) {
      setSubpageInfo(null);
      return;
    }

    setSubpageLoading(true);
    setSubpageError('');

    fetch(subpageURL)
      .then(res => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then(data => setSubpageInfo(data))
      .catch(err => setSubpageError(err))
      .finally(() => setSubpageLoading(false));
  }, [subpageURL]);

  useInterceptLinks((href) => {
    console.log('link:', href);
    if (href.startsWith('/')) {
      setSubpageURL('https://content.democrats.com/wp-json/wp/v2/pages?slug=' + href.slice(1));
    } else {
      window.open(href);
    }
  })

  const handleGoBack = () => {
    setSubpageInfo(null);
    setSubpageURL('');
  }

  const html = data?.length && data[0] && data[0].content?.rendered;
  const subpageHtml = subpageInfo?.length && subpageInfo[0] && subpageInfo[0]?.content?.rendered;
  

  useIonViewWillEnter(() => {
    setHeader({
      children: (
        <>
          <IonTitle>Info</IonTitle>
        </>
      )
    });
  });
  
  useIonViewWillLeave(() => {
    setHeader({});
    setSubpageURL('');
    setSubpageInfo(null);
  });

  return (
    <IonPage className="grey-bg">      
      {loading || subpageLoading
        ? <CenteredSpinner />
        : (
            <AppContent scrollY fullscreen className="ion-padding">
            {subpageHtml
              ? <div dangerouslySetInnerHTML={{ __html: subpageHtml }} />
              : null
            }
            {html && !subpageHtml
              ? <div dangerouslySetInnerHTML={{ __html: html }} />
              : null
            }
            {subpageHtml
              ? (
                <div className="ion-text-center" style={{marginTop: 10}}>
                  <IonButton onClick={handleGoBack}>
                    Back
                  </IonButton>
                </div>
              )
              : null
            }
          </AppContent>
        )
      }
    </IonPage>
  );
}
